import type {SidebarValues} from "./App.tsx";
import Source from "./components/Source.tsx";
import {type Dispatch, type SetStateAction, useMemo} from "react";
import type {TouchingBoundary} from "./Scene.tsx";

type SourcesProps = {
    dimensions: { width: number; height: number; depth: number, sphereDiameter: number };
    setValues: SidebarValues;
    setTouchingBoundary: Dispatch<SetStateAction<TouchingBoundary>>;
}

export type SourceState = "none" | "loading" | "ready" | "running" | "error";

export const minDB = -60;
export const maxHorizontalAngel = 90;
export const maxVerticalAngel = 45;

export type SceneBoundaries = { maxX: number, maxY: number, minZ: number };

/**
 * The audio sources.
 * @param dimensions the dimensions of the scene in three's coordinate system
 * @param setValues callback to set values in the sidebar
 * @param setTouchingBoundary callback to notify the boundary is touched
 */
export default function Sources({dimensions, setValues, setTouchingBoundary}: SourcesProps) {

    const {width, height, depth, sphereDiameter} = dimensions;
    const sceneBoundaries = useMemo(() => {
        return {
            maxX: width / 2,
            maxY: height / 2,
            minZ: -depth
        }
    }, [width, height, depth]);

    return (<>
            <Source label={"Bedienung"} shape={"cube"}
                    sourceType={"intern"} url={'/intern/ddd-scene-basics_de.mp3'}
                    // default is center, -6 dB
                    orientation={{rotY: -5, rotX: -5}}
                    boundaries={sceneBoundaries} size={sphereDiameter} setValues={setValues}
                    setTouchingBoundary={setTouchingBoundary}
                   />

            <Source label={"Anti Alles"} shape={"tetrahedron"} autoload={false}
                    sourceType={"fetch"} url={'/intern/AntiAlles.mp3'} panning={{vertical: false}}
                    initial={{dB: -10, horizontal: 90, vertical: -20}}
                    boundaries={sceneBoundaries} size={sphereDiameter} setValues={setValues}
                    setTouchingBoundary={setTouchingBoundary}
                    />

            <Source label={"footsteps"} loop={true}
                    sourceType={"intern"} url={'/intern/Footsteps.wav'}
                    initial={{dB: -20, horizontal: -90, vertical: -45}}
                    boundaries={sceneBoundaries} size={sphereDiameter} setValues={setValues}
                    setTouchingBoundary={setTouchingBoundary}
                    />
        </>
    );
}
